import { Input } from 'antd';
import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { FormProps } from '../types';
import { Arrow } from '@src/components/Arrow';

interface FormReferralCodeProps extends FormProps {
  isOpen?: boolean;
}

export function FormReferralCode({
  isOpen: isOpenProp,
  control,
  name,
}: FormReferralCodeProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof isOpenProp === 'boolean') {
      setIsOpen(isOpenProp);
    }
  }, [isOpenProp]);

  return (
    <div className='space-y-2'>
      <div
        className='flex items-center cursor-pointer text-gray-3 gap-1'
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <Arrow direction='down' className='text-black' />
        ) : (
          <Arrow direction='right' className='text-black' />
        )}
        Do you have a referral code?
      </div>
      {isOpen && (
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <Input
              size='large'
              variant='filled'
              {...field}
              className='text-gray-3 py-4 px-5 rounded-2xl'
              placeholder='Referral code'
            />
          )}
        />
      )}
    </div>
  );
}
